import React from 'react';
import ManageInstrumentTypeComponentVM from './ManageInstrumentTypeComponentVM';
import { observer } from 'mobx-react';
import { Neo } from '@singularsystems/neo-react';
import { TextConstants } from '../../../Common/TextConstants';
import { ModalUtils, Validation } from '@singularsystems/neo-core';

interface IManageInstrumentTypeComponentProps {
    viewModel: ManageInstrumentTypeComponentVM;
    onCancel: () => void;
    onSave: () => void;
}

@observer
export default class ManageInstrumentTypeComponent extends React.Component<IManageInstrumentTypeComponentProps> {

    public render() {
        const viewModel = this.props.viewModel;

        return (
            <div>
                {<Neo.Card title={TextConstants.Titles.InstrumentTypeDetails}>
                    <div>
                        {viewModel.instrumentTypeName
                            &&
                            <p><em>{`Instrument Type: ${viewModel.instrumentTypeName}`}</em></p>}
                    </div>
                    <div>
                        <Neo.Form 
                            model={viewModel.instrumentTypeName === "" ? viewModel.managedInstrumentType : viewModel.managedInstrumentSubtype}
                            onInvalid={this.onFormInvalid}
                            onSubmit={() => this.props.onSave()}
                            validationDisplayMode={Validation.DisplayMode.AfterSubmit}>
                            <Neo.GridLayout lg={3}>
                                <Neo.FormGroup
                                    label={viewModel.instrumentTypeName === "" ? TextConstants.Labels.InstrumentTypeName : TextConstants.Labels.InstrumentSubTypeName}
                                    bind={viewModel.instrumentTypeName === "" ? viewModel.managedInstrumentType.meta.instrumentTypeName : viewModel.managedInstrumentSubtype.meta.instrumentSubTypeName} />
                            </Neo.GridLayout>
                            <div className="row customMarginTop29 float-right pr-3">
                                <Neo.Button 
                                    variant="primary" className="ml-3 col-md-2" isSubmit
                                >{TextConstants.Buttons.Save}</Neo.Button>
                                <Neo.Button className="ml-3 col-md-2"
                                    onClick={() => this.props.onCancel()}
                                    variant="secondary"
                                >{TextConstants.Buttons.Cancel}</Neo.Button>
                            </div>

                        </Neo.Form>
                    </div>
                </Neo.Card>}
            </div>
        );
    }

    private onFormInvalid(e: React.FormEvent) {
        ModalUtils.showMessage("Save", TextConstants.Validation.InvalidInstrumentType);
    }
}